export var menuItems = {
  data: [
    {
      path: "/dashboard",
      title: "Dashboard",
      type: "link",
      active: false,
    },
    {
      title: "Header",
      type: "sub",
      active: false,
      children: [
        {
          path: "/admin/header/mainmenu",
          title: "MM",
          type: "link",
          active: false,
        },
        {
          path: "/admin/header/hamburgermenu",
          title: "HM",
          type: "link",
          active: false,
        },
        {
          path: "/admin/header/responsivemenu",
          title: "RM",
          type: "link",
          active: false,
        },
        {
          path: "/admin/header/iconmenu",
          title: "IM",
          type: "link",
          active: false,
        },
      ],
    },
    {
      path: "/admin/footer",
      title: "Footer",
      type: "link",
      active: false,
    },
    {
      path: "/admin/media",
      title: "Media",
      type: "link",
      active: false,
    },
    // {
    //   "path": "/app/filemanager",
    //   "title": "File manager",
    //   "icon": "stroke-file",
    //   "iconf":"fill-file",
    //   "type": "link",
    //   "active": false
    // },
    {
      title: "Pages",
      type: "sub",
      active: false,
      children: [
        {
          path: "/admin/pages/home",
          title: "Home",
          type: "link",
          active: false,
        },
        {
          path: "/admin/pages/about-us",
          title: "About Us",
          type: "link",
          active: false,
        },
        {
          path: "/admin/pages/menu",
          title: "Menu",
          type: "link",
          active: false,
        },
        {
          path: "/admin/pages/community",
          title: "Community",
          type: "link",
          active: false,
        },
        {
          path: "/admin/pages/mcd-app",
          title: "McDonald's App",
          type: "link",
          active: false,
        },
        {
          path: "/admin/pages/work-with-us",
          title: "Work With Us",
          type: "link",
          active: false,
        },
        {
          path: "/admin/pages/promotion",
          title: "Promotion",
          type: "link",
          active: false,
        },
        {
          path: "/admin/pages/contact-us",
          title: "Contact Us",
          type: "link",
          active: false,
        },
        {
          path: "/admin/pages/faqs",
          title: "FAQs",
          type: "link",
          active: false,
        },
        {
          path: "/admin/pages/privacy-policy",
          title: "Privacy & Policy",
          type: "link",
          active: false,
        },
        {
          path: "/admin/pages/terms-conditions",
          title: "Terms & Conditions",
          type: "link",
          active: false,
        },
      ],
    },
    {
      path: "/admin/approval",
      title: "Approval",
      type: "link",
      badgeType: "danger",
      badgeValue: "2",
      active: false,
      roles: ['Approver']
    },
    {
      path: "/admin/logs",
      title: "Logs",
      type: "link",
      active: false,
    },
    {
      path: "/admin/settings",
      title: "Settings",
      type: "link",
      active: false,
    },
    {
      type: "headtitle",
    },
    {
      title: "Support",
      path: "/admin/Support",
      type: "link",
      active: false,
    },
    {
      path: "/admin/Profile",
      title: "Profile",
      type: "link",
      active: false,
    },
    {
      path: "",
      title: "Log Out",
      slug: "log-out",
      icon: "stroke-faq",
      iconf: "fill-faq",
      type: "link",
      active: false,
    },
  ],
};
